var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isMdUp
    ? _c(
        "w-row",
        {
          staticClass: "header",
          style: { padding: "10px", fontWeight: "bold" },
        },
        [
          _c("w-col", { attrs: { md: _vm.showTotal ? 3 : 4 } }, [
            _vm._v(_vm._s(_vm.$ct("header.document"))),
          ]),
          _c("w-col", { attrs: { md: "2" } }, [
            _vm._v(
              _vm._s(
                _vm.$ct(_vm.additional ? "header.date" : "header.invoice-date")
              )
            ),
          ]),
          !_vm.additional
            ? _c("w-col", { attrs: { md: "2" } }, [
                _vm._v(_vm._s(_vm.$ct("header.expiration-date"))),
              ])
            : _vm._e(),
          _vm.showTotal
            ? _c("w-col", { attrs: { md: "2" } }, [
                _vm._v(_vm._s(_vm.$ct("header.incl"))),
              ])
            : _vm._e(),
          _c("w-col", { attrs: { md: _vm.showTotal ? 1 : 2 } }, [
            _vm._v(_vm._s(_vm.open ? _vm.$ct("header.open") : "")),
          ]),
          _c("w-col", { attrs: { md: "1" } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }